
export const GET_STANDERD_BUSINESS_ACTIVITY = "GET_STANDERD_BUSINESS_ACTIVITY"
export const GET_USERS_DATA = "GET_USERS_DATA"

